import React from "react";

const Dropdown = ({ items, type, selectedItems, onItemClick, isOpen }) => {
    return (
      <div className={`dropdown-content ${isOpen ? "show" : ""}`}>
        {items.map((item, index) => (
          <div
            key={index}
            className={`dropdown-item ${selectedItems.includes(item) ? "selected" : ""}`}
            onClick={() => onItemClick(type, item)}
          >
            {item}
          </div>
        ))}
      </div>
    );
  };

export default Dropdown;